module.exports = __webpack_public_path__ + "static/media/noti_profile.be0bc197.png";